































































import {Component, Prop, Vue} from 'vue-property-decorator';
import {User} from '@/oauth/User';
import {Authority} from '@/oauth/Authority';
import {SecurityUtils} from '@/oauth/SecurityUtils';
import {AuthorityDto} from '@/oauth/AuthorityDto';

export interface QTree extends Vue {
  setExpanded: (key: string, state: boolean) => void;
}

@Component
export default class AuthorityControl extends Vue {
  @Prop({default: () => new User()}) private user!: User;
  private selectedType = '角色';
  private authority: Authority = new Authority();
  private authorities = SecurityUtils.getAllAuthorities();
  private userAuthorityTree: QTreeNode[] = [];
  private permissionTree: QTreeNode[] = [];
  private permissionSelected = '';
  private roleSelected = '';
  private SecurityUtils = SecurityUtils;
  private isDragging = false;




  private getTrees() {
    const allRole = SecurityUtils.getAllRole();
    const allPermission = SecurityUtils.getAllPermission();
    const otherTag = SecurityUtils.getOtherAuthority();
    this.permissionTree = [{
      label: '可用标签',
      children: [{
        label: '权限',
        children: SecurityUtils.createNodeTree(allPermission),
      }, {
        label: '角色',
        children: SecurityUtils.createNodeTree(allRole),
      }, {
        label: '其他标签',
        children: SecurityUtils.createNodeTree(otherTag),
      }],
    }];
    this.userAuthorityTree = [{
      label: '用户的标签',
      header: 'dropAble',
      children: this.getUserAuthority(),
    }];
  }

  private getUserAuthority() {
    const map1: Array<{ header: string; label: string }> = [];
    SecurityUtils.getAllPermission(this.user.authorities).map((authority) => {
      map1.push({
        label: authority.authority,
        header: 'permission',
      });
    });
    SecurityUtils.getAllRole(this.user.authorities).map((authority) => {
      map1.push({
        label: authority.authority,
        header: 'permission',
      });
    });
    SecurityUtils.getOtherAuthority(this.user.authorities).map((authority) => {
      map1.push({
        label: authority.authority,
        header: 'permission',
      });
    });
    return map1;
  }

  private addUser() {
    if (!this.user.authorities.some((authority) => {
      return this.permissionSelected === authority.authority;
    })) {
      const addAuthority = this.authorities.filter((auth) => {
        return auth.authority === this.permissionSelected;
      })[0];
      this.user.authorities.push(addAuthority);
    }

  }

  private async postAuthority() {
    const a = this.authority;
    if (this.selectedType === '角色') {
      a.authority = 'ROLE_' + a.authority;
    } else if (this.selectedType === '权限') {
      a.authority = 'PERMISSION_' + a.authority;
    }
    a.authority = a.authority.toUpperCase();
    await AuthorityDto.addAuthority(a);
    this.$q.notify('新增成功');
    this.authority.authority = '';
    await this.getAllAuthorities();
  }

  private async getAllAuthorities() {
    this.authorities = await SecurityUtils.refreshAuthorities();
    this.getTrees();
  }

  private async handlePermissionDrop(n: QTreeNode) {
    this.isDragging = false;
    await this.insertPermissionToRole(n);
  }

  private async insertPermissionToRole(role: QTreeNode) {
    if (role === null) {
      return;
    }
    const children: QTreeNode[] | undefined = role.children;
    if (children !== undefined) {
      SecurityUtils.joinTree(children, [{
        label: this.permissionSelected,
        header: 'permission',
      }]);
      this.addUser();
      const userAuthorityTree: QTree = this.$refs.userAuthorityTree as QTree;
      userAuthorityTree.setExpanded(this.permissionSelected, true);
    }
  }

  private async deleteAuthority(authority: string) {
    try {
      const auth = this.authorities.filter((a) => {
        return a.authority === authority;
      })[0];
      await AuthorityDto.deleteAuthority(auth);
      await this.getAllAuthorities();
    } catch (e) {
      this.$q.notify({message: '错误:' + e, color: 'red'});
    }


  }

  private async handleDelete(role: string, permission: string) {
    const qTreeNodes = this.userAuthorityTree[0];
    if (qTreeNodes.children) {
      qTreeNodes.children = qTreeNodes.children.filter((node) => {
        return node.label !== permission;
      });
    }
    this.user.authorities = this.user.authorities.filter((authority) => {
      return authority.authority !== permission;
    });
  }

  expandSelected(keys: string) {
    const tree= this.$refs.tree as unknown as {setExpanded: (keys: string,b: boolean) => void};
    tree.setExpanded(keys, true);
  }

  private mounted() {
    document.addEventListener('dragover', (ev) => {
      this.isDragging = false;
    });
    this.getAllAuthorities();
  }
}
